import { useParams } from 'react-router';

import { useGetByInventoryId } from 'src/api/inventories';

// ----------------------------------------------------------------------

export const useInventoryName = () => {
  const { inventory_id } = useParams();
  const { inventories, inventoriesLoading } = useGetByInventoryId(inventory_id, 'name');
  if (inventoriesLoading) return '...';
  return inventories[0]?.name || '';
};

// ----------------------------------------------------------------------

const InventoryName = () => useInventoryName();

InventoryName.propTypes = {};

export default InventoryName;
